exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col-maps .mapboxgl-map {\n  height: 1000px;\n}\n.mapboxgl-popup-content .estate-card {\n  margin-bottom: 0;\n  min-height: 325px;\n  min-width: 348px;\n}", ""]);

// exports
